import styled from 'react-emotion';
import Page from '../layout/Page';
import React, {Component} from 'react';
import {Menu} from 'semantic-ui-react';
import {ROLES} from '../../constants';
import {NavLink, Switch} from 'react-router-dom';
import {connect} from 'react-redux';
import RequiresRole from '../security/RequiresRole';
import AuthorizedRoute from '../security/AuthorizedRoute';
import AllWhitelistsTable from '../whitelists/AllWhitelistsTable';
import NewWhitelistScreen from './NewWhitelistScreen';
import AllWhitelistedDomainTable from './AllWhitelistedDomainTable';
import NewWhitelistDomainScreen from './NewWhitelistDomainScreen';

const PageWrapper = styled(Page.Basic)`
  .ui.menu .item {
    height: 42px;

    > .label.request-badge {
      background: #dfae38;
    }
  }
`;


class IndexScreen extends Component {
  render() {
    return (
      <PageWrapper
        title="Manage Whitelist"
        secondary={
          <Menu secondary pointing>
            <RequiresRole roles={[ROLES.SYSTEM_ADMIN]}>
              <Menu.Item as={NavLink} to="/manage/whitelists" exact>
                Whitelisted Users
              </Menu.Item>
              <Menu.Item as={NavLink} to="/manage/whitelists/new">
                Whitelist a User
              </Menu.Item>
              <Menu.Item as={NavLink} to="/manage/whitelists/domains" exact>
                Whitelisted Domains
              </Menu.Item>
              <Menu.Item as={NavLink} to="/manage/whitelists/domains/new">
                Whitelist New Domain
              </Menu.Item>
            </RequiresRole>
          </Menu>
        }
      >
        <Switch>
          <AuthorizedRoute
            exact
            path="/manage/whitelists"
            component={AllWhitelistsTable}
            roles={[ROLES.SYSTEM_ADMIN]}
          />
          <AuthorizedRoute
            exact
            path="/manage/whitelists/new"
            component={NewWhitelistScreen}
            roles={[ROLES.SYSTEM_ADMIN]}
          />
          <AuthorizedRoute
            exact
            path="/manage/whitelists/domains"
            component={AllWhitelistedDomainTable}
            roles={[ROLES.SYSTEM_ADMIN]}
          />
          <AuthorizedRoute
            exact
            path="/manage/whitelists/domains/new"
            component={NewWhitelistDomainScreen}
            roles={[ROLES.SYSTEM_ADMIN]}
          />
        </Switch>
      </PageWrapper>
    );
  }
}

const mapStateToProps = ({identity}) => {
  return {
    user: identity.user,
  };
};

export default connect(mapStateToProps)(IndexScreen);
